const resolveDisplayName = (entity) => entity?.display_name
  || entity?.displayName
  || entity?.name
  || entity?.contact_name
  || [entity?.client_first_name, entity?.client_last_name].filter(Boolean).join(' ')
  || entity?.client_name
  || [entity?.first_name, entity?.last_name].filter(Boolean).join(' ')
  || '';

const UI_ONLY_ENTITY_FIELDS = new Set(['_interactionType', 'cardIndex', 'action']);
const FALLBACK_ENTITY_HIDDEN_FIELDS = new Set(['type', ...UI_ONLY_ENTITY_FIELDS]);

const isUiOnlyEntityField = (key) => UI_ONLY_ENTITY_FIELDS.has(key);
const isFallbackEntityHiddenField = (key) => FALLBACK_ENTITY_HIDDEN_FIELDS.has(key);

const buildSelectedEntityPayload = (entity) => Object.fromEntries(
  Object.entries(entity || {}).filter(([key]) => !isUiOnlyEntityField(key)),
);

const buildEntityTopicTitle = (entity) => {
  const displayName = resolveDisplayName(entity);
  if (entity?.type === 'appointment') return displayName ? `Appointment with ${displayName}` : 'Appointment';
  if (entity?.type === 'matter') return displayName;
  if (entity?.type === 'payment_request') return 'Payment request';
  const type = entity?.type || '';
  return [type, displayName].filter(Boolean).join(': ') || type;
};

const resolveRadioSelectionText = (entity) => {
  if (entity?.title) return entity.title;
  return resolveDisplayName(entity) || entity?.uid || '';
};

export { buildSelectedEntityPayload, isFallbackEntityHiddenField, isUiOnlyEntityField, resolveRadioSelectionText };
export default buildEntityTopicTitle;
